import { Card } from 'antd'
import * as propsType from 'prop-types'
import philipLogo from '../../assets/images/philips-logo.png'
import './styles.scss'

const CourseRegistrationLayout = ({ course, children }) => {
  if (!course) {
    return null
  }

  const bgColor = course.registration_form.settings?.background || '#23426B'
  let logo = course.registration_form.settings?.logo
  if (logo) {
    logo = `${window.location.origin}/images/registration-page/logos/${logo}`
  }

  return (
    <div
      style={{
        backgroundColor: 'lightgray',
        paddingBottom: 20,
        minHeight: '100vh'
      }}
    >
      <div
        style={{
          maxWidth: 720,
          margin: 'auto',
          backgroundColor: bgColor
        }}
      >
        <div
          style={{
            maxWidth: '100%',
            margin: 'auto',
            padding: 20,
            paddingLeft: 40,
            paddingRight: 40,
            color: 'white'
          }}
          className='registration-layout'
        >
          <div style={{ textAlign: 'center', marginBottom: 20 }}>
            <img
              src={logo ?? philipLogo}
              style={course.registration_form.settings?.logo_styles}
            />
          </div>
          <h2
            style={{
              color: 'white',
              textAlign: 'center',
              fontSize: 20,
              lineHeight: 'normal'
            }}
          >
            {course.registration_form?.title}
          </h2>

          <div
            dangerouslySetInnerHTML={{
              __html: course.registration_form?.content
            }}
          ></div>
        </div>

        <Card
          variant='borderless'
          style={{ maxWidth: '100%', margin: 'auto', marginBottom: 40 }}
          loading={course == null}
        >
          {children}
        </Card>
      </div>
    </div>
  )
}

CourseRegistrationLayout.propTypes = {
  course: propsType.object.isRequired,
  children: propsType.any
}

export default CourseRegistrationLayout
